'use client'

import { useEffect, useRef, useState } from 'react'

import carFallbackImage from '../_assets/car-fallback.png'

interface IHeroCarsProps {
  /** 상위 3개 차종 이미지 URL (rank 1~3). 부족하면 있는 만큼만 노출. */
  imageUrls: string[]
}

/** 히어로 차 1대 — 로드 실패 시 리스트아이템처럼 기본 차량 이미지로 폴백 */
const HeroCar = ({ url, className }: { url: string; className: string }) => {
  const [failed, setFailed] = useState(false)
  const imgRef = useRef<HTMLImageElement>(null)

  // SSR HTML에서 이미 실패한 이미지는 onError를 놓칠 수 있어 마운트 시 재확인
  useEffect(() => {
    const img = imgRef.current
    if (img && img.complete && img.naturalWidth === 0) setFailed(true)
  }, [])

  return (
    <img
      ref={imgRef}
      src={failed ? carFallbackImage.src : url}
      alt=''
      aria-hidden
      className={`${className} aspect-[160/90] object-contain`}
      onError={() => setFailed(true)}
    />
  )
}

/**
 * 히어로 카드 차 이미지 3대 배치 — Figma 8877:294985 / 8943:297266
 * 좌상=2위 · 우상=3위 · 하단 중앙 큰 한 대=1위. 이미지 없으면 기본 차량 이미지로 폴백.
 */
const HeroCars = ({ imageUrls }: IHeroCarsProps) => {
  // 좌상 / 우상 / 하단 배치 — Figma 8877:294985 (226×127 컨테이너 기준)
  // 좌상·우상 100×56.25, 하단 130×73(좌측으로 치우침). 값은 컨테이너 대비 %.
  // rank: imageUrls 인덱스(0=1위, 1=2위, 2=3위) 매핑.
  const slots = [
    { className: 'absolute left-[6.19%] top-[7.87%] w-[44.25%]', rank: 1 }, // 좌상=2위
    { className: 'absolute right-0 top-[7.87%] w-[44.25%]', rank: 2 }, // 우상=3위
    { className: 'absolute bottom-0 left-[15.49%] w-[57.52%]', rank: 0 }, // 하단=1위
  ]

  return (
    <div className='relative h-full w-full'>
      {slots.map(({ className, rank }) => (
        <HeroCar
          key={className}
          url={imageUrls[rank] ?? carFallbackImage.src}
          className={className}
        />
      ))}
    </div>
  )
}

export default HeroCars
